import React from 'react';
import PropTypes from 'prop-types';
import ConfirmAddress from './confirm-address';
import PickAddress from './pick-address';
import BypassValidation from './bypass-validation';

const VerifyAddressModal = (props) => {
  if (props.verifyLevel === 'InteractionRequired') {
    return <ConfirmAddress { ...props } />;
  } else if (props.verifyLevel === 'Multiple') {
    return <PickAddress { ...props } />;
  } else if (props.verifyLevel === 'Unverified') {
    return <BypassValidation { ...props } />;
  } else {
    return null;
  }
};

VerifyAddressModal.propTypes = {
  verifyLevel: PropTypes.string
};

export default VerifyAddressModal;
